import { createAction } from '@reduxjs/toolkit';

export const END_CONVERSATION_ACTION_TYPE = 'saga/endConversation';
export const endConversationAction = createAction(END_CONVERSATION_ACTION_TYPE);
